var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var FinderOpened = function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 1024 832", width: "1em", height: "1em" }, props),
    React.createElement("path", { d: "M1009.48 311.43A63.75 63.75 0 0 0 960 288H246.22a95.7 95.7 0 0 0-94.7 80.22L96.44 698.74a32 32 0 1 0 63.12 10.52l55.09-330.52A31.91 31.91 0 0 1 246.22 352H960l-78.07 390.28A32.08 32.08 0 0 1 850.56 768H96a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32h253.75a31.93 31.93 0 0 1 26.62 14.25l45 67.5A32 32 0 0 0 448 160h352a32 32 0 0 1 32 32v32a32 32 0 0 0 64 0v-32a96.11 96.11 0 0 0-96-96H465.13l-35.5-53.25A95.82 95.82 0 0 0 349.75 0H96A96.11 96.11 0 0 0 0 96v640a96.11 96.11 0 0 0 96 96h754.56a96.26 96.26 0 0 0 94.13-77.17l78.06-390.28a63.76 63.76 0 0 0-13.27-53.12z", fill: "currentColor", "data-name": "Layer 2" }))); };
export default FinderOpened;
//# sourceMappingURL=FinderOpened.js.map